import { SHOW_BAG_BANNER } from "@template/state/modules/infoBanner";
import { getViewport, SMALL_VIEWPORT } from "@template/state/modules/layout";

import { RESERVATION_BANNER } from "./constants";

const subscribeToUpdatesCallback = ({ oldQuantity, dispatch, state }) => ({
  bag: {
    summary: { totalQuantity: newQuantity }
  }
}) => {
  if (newQuantity > oldQuantity && getViewport(state) === SMALL_VIEWPORT) {
    dispatch({
      type: SHOW_BAG_BANNER,
      bannerType: RESERVATION_BANNER
    });
  }
};

export default subscribeToUpdatesCallback;
